/*
 * Copyright (c) 2019. Ratespecial Interactive
 */

// export enum CtaStatus {
//   NEW,
//   CLICKED,
//   COMPLETED,
//   DISMISSED,
//   INVALIDATED
// }


export enum CtaStatus {
  NEW = 'NEW',
  CLICKED = 'CLICKED',
  COMPLETED = 'COMPLETED',
  DISMISSED = 'DISMISSED',
  INVALIDATED = 'INVALIDATED'
}
